import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const recordHotspotIntent = async (hotspotId) => {
  try {
    // Get JWT token from localStorage (injected by bifrost webview)
    const token = localStorage.getItem("token");

    if (!token) {
      console.error("No JWT token found in localStorage");
      return { success: false, error: "No authentication token" };
    }

    const { data: response } = await axios.post(
      `${API_BASE_URL}/v2/hotspots/${hotspotId}/record-intent`,
      null,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return { success: true, data: response };
  } catch (error) {
    return { success: false, error };
  }
};

export const checkHotspotIntent = async (hotspotId) => {
  try {
    // Get JWT token from localStorage (injected by bifrost webview)
    const token = localStorage.getItem("token");

    if (!token) {
      console.error("No JWT token found in localStorage");
      return { success: false, error: "No authentication token" };
    }

    const { data: response } = await axios.get(
      `${API_BASE_URL}/v2/hotspots/${hotspotId}/check-intent`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return { success: true, data: response };
  } catch (error) {
    return { success: false, error };
  }
};
